import React, { useState } from "react";
import "./Navbar.scss";
import { HiMenu, HiX } from "react-icons/hi";
import { BsMoonStarsFill, BsFillSunFill } from "react-icons/bs";
import { motion } from "framer-motion";
import { images } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { changeTheme } from "../../state/features/changeTheme/changeThemeSlice";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const isDarkTheme = useSelector((state) => state.theme.isDarkTheme);
  const dispatch = useDispatch();

  const handleThemeChange = () => {
    isDarkTheme ? dispatch(changeTheme(false)) : dispatch(changeTheme(true));
  };

  return (
    <nav className="app__navbar">
      <a href="#home" alt="home">
        <div className="app__navbar-logo">
          <img src={images.logo} alt="logo" />
        </div>
      </a>
      {!toggle && (
        <>
          <ul className={`${"app__navbar-links"}`}>
            {["home", "work", "skills", "contact"].map((item) => {
              return (
                <li className="app__flex p-text" key={`link-${item}`}>
                  <div></div>
                  <a href={`#${item}`}>{item}</a>
                </li>
              );
            })}
          </ul>

          {/* <div
            className={`app__navbar-darkmode app__navbar-theme ${
              isDarkTheme && "dark-checkbox"
            }`}
          >
            <input
              type="checkbox"
              className="checkbox"
              id="checkbox"
              onChange={handleThemeChange}
              checked={isDarkTheme}
            />
            <label htmlFor="checkbox" className="label">
              <BsFillSunFill color="yellow" />
              <BsMoonStarsFill color="white" />
              <div className="ball"></div>
            </label>
          </div> */}
        </>
      )}
      <div className={`${"app__navbar-menu"}`}>
        <HiMenu
          onClick={() => {
            setToggle(true);
          }}
        />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: "easeOut" }}
            className={`${"app__menu-motion-div"}`}
          >
            <HiX
              onClick={() => {
                setToggle(false);
              }}
              className="app__navbar-menu-svg"
            />
            <ul>
              {["home", "work", "skills", "contact"].map((item) => {
                return (
                  <li key={item}>
                    <a
                      href={`#${item}`}
                      onClick={() => {
                        setToggle(false);
                      }}
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
            {/* <div
              className={`app__navbar-darkmode app__menu-theme ${
                isDarkTheme && "dark-checkbox"
              }`}
            >
              <input
                type="checkbox"
                className="checkbox"
                id="checkbox"
                onChange={handleThemeChange}
                checked={isDarkTheme}
              />
              <label htmlFor="checkbox" className="label">
                <BsFillSunFill color="yellow" />
                <BsMoonStarsFill color="white" />
                <div className="ball"></div>
              </label>
            </div> */}
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
